export { ErrorResult } from './error-result'
